import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, Loader2, Upload } from "lucide-react";
import { API, errorMessage } from "../../lib/api";
import { Field } from "./Field";

export const FileUpload = ({ testId, label, docType, value, onChange, maxMb = 5, accept = "image/jpeg,image/png,image/webp,application/pdf", hint = "image or PDF, max 5 MB" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > maxMb * 1024 * 1024) return toast.error(`File too large (max ${maxMb} MB)`);
    const body = new FormData();
    body.append("doc_type", docType);
    body.append("file", file);
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/kyc/upload`, body);
      onChange({ id: data.file_id, name: file.name });
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Field label={label} hint={hint}>
      <input ref={ref} type="file" accept={accept} className="hidden"
        data-testid={`${testId}-input`} onChange={onFile} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId}
        className={`flex h-11 w-full items-center gap-2 border border-dashed px-3 text-left text-sm transition-colors ${value ? "border-emerald-500/50 text-emerald-300" : "border-white/20 text-slate-400 hover:border-orange-500 hover:text-white"}`}>
        {busy ? <Loader2 className="h-4 w-4 shrink-0 animate-spin" /> : value ? <CheckCircle2 className="h-4 w-4 shrink-0" /> : <Upload className="h-4 w-4 shrink-0" />}
        <span className="truncate">{busy ? "Uploading..." : value ? value.name : "Choose file"}</span>
      </button>
    </Field>
  );
};
